<template>
    <header class="main-layout__header main-layout__header--mobile">
        <div class="main-layout__container">
            <div class="main-header">
                <img
                    src="@/assets/icons/profile.svg"
                    class="main-header__profile--mobile"
                    @click="openProfileModal"
                />

                <img
                    src="@/assets/icons/logo-big.svg"
                    class="main-header__logo"
                    @click="goToAuctionsListPage"
                />

                <UIMenuButton
                    class="main-header__menu--mobile"
                    :opened="mobileMenuOpened"
                    @click="mobileMenuOpened = !mobileMenuOpened"
                />
            </div>
        </div>
    </header>

    <HeaderMobileNavigation :opened="mobileMenuOpened" @close="mobileMenuOpened = !mobileMenuOpened" />
</template>

<script lang="ts" setup>
    import { ref } from 'vue';
    import { useRouter } from 'vue-router';

    import { injectStrict } from '@/injection/injectStrict.ts';
    import { ModalPluginType } from '@/plugins/modalPlugin.ts';
    import { ModalKey } from '@/injection/keys.ts';

    import UIMenuButton from '@/components/ui/UIMenuButton/UIMenuButton.vue';

    import HeaderMobileNavigation from '@/layouts/MainLayout/components/HeaderMobileNavigation/HeaderMobileNavigation.vue';
    import ProfileModal from '@/modals/ProfileModal/ProfileModal.vue';

    const $modal = injectStrict<ModalPluginType>(ModalKey);

    const router = useRouter();

    const mobileMenuOpened = ref<boolean>(false);

    function goToAuctionsListPage(): void {
        router.push({ name: 'AuctionsList' });
    }

    function openProfileModal(): void {
        $modal.open({
            component: ProfileModal,
        });
    }
</script>
